import { FC } from 'react';
import { DetailsBooking } from 'types';
import { ContentHeading } from 'components/Typography';
import QantasPointsEarnCard from './QantasPointsEarnCard';
import { mapPointsClubTierProp } from './helpers';

const QantasPointsEarn: FC<{ booking: DetailsBooking }> = ({ booking }) => {
  const { totalQffPointsEarned, totalQffPointsAwarded, totalQbrPoints, pointsClubTier } = booking.reservation;
  const showQantasPointsEarn = totalQffPointsEarned + totalQffPointsAwarded + totalQbrPoints > 0;

  return showQantasPointsEarn ? (
    <>
      <ContentHeading>Qantas Points</ContentHeading>
      <QantasPointsEarnCard
        earnedPoints={totalQffPointsEarned}
        awardedPoints={totalQffPointsAwarded}
        qbrPoints={totalQbrPoints}
        pointsClubTier={mapPointsClubTierProp(pointsClubTier)}
      />
    </>
  ) : null;
};

export default QantasPointsEarn;
